import { CellData, TableData } from '@ddt-web/data-service';
import { FundsToExploreGroup } from '@ddt-web/rules-engine';
import * as get from 'lodash/get';

export class AreasToExploreDataUtil {
	public static maximumFundsToExploreGroupPerRow: number = 3;

	public static getFundsToExploreData(data: TableData, portfolioIndex: number): [FundsToExploreGroup[], number] {
		const portfolioData: CellData[] = get(data, `cells[${portfolioIndex}]`);
		const fundsDataIndex = data?.headersX?.findIndex(headerX => headerX.rawValue === 'fundsToExplore');

		const fundsData: FundsToExploreGroup[] = (portfolioData?.[fundsDataIndex]?.rawValue ?? []) as any[];
		const fundsDataGroupPerRow = Math.min(fundsData.length, this.maximumFundsToExploreGroupPerRow);
		return [fundsData, fundsDataGroupPerRow];
	}
}
